/*
 * @Version    : v1.00
 * @Author     : generated
 * @Date       : 2025-11-20
 * @desc       : 尼泊尔语 国际化语言文件
 */
// 尼泊尔语.js
export default {
  centerAgent: {
    subagency: "उप-एजेन्सी",
    search: "खोज्नुहोस्",
    subagencyIncome: "उप-एजेन्सी आय",
    last29Days: "पछिल्लो २९ दिन",
    excludingToday: "आज बाह्य",
    commission: "कमिसन",
    last30Days: "पछिल्लो ३० दिनको डेटा",
    rank: "रैंक",
    hostNumber: "होस्ट संख्या",
    recent30Days: "पछिल्लो ३० दिनको होस्ट आय",
    commissionRate: "कमिसन दर",
    myCommission: "मेरो कमिसन",
    remove: "हटाउनुहोस्",
    thisAction:
      "यो कार्यले तपाईंको टोलीबाट {hostoragent} {hostname} हटाउनेछ। के तपाईं अगाडि बढ्न निश्चित हुनुहुन्छ?",
    dashboard: "ड्यासबोर्ड",
    information: "जानकारी",
    dataCenter: "डेटा केन्द्र",
    hostList: "होस्ट सूची",
    bdList: "बीडी सूची",
    agencyList: "एजेन्सी सूची",
    myRight: "मेरो अधिकार",
    numberOf: "एजेन्सी संख्या",
    inviteAgency: "एजेन्सी आमन्त्रित गर्नुहोस्",
    numberOfHost: "होस्ट संख्या",
    inviteHost: "होस्ट आमन्त्रित गर्नुहोस्",
    inviteHostlinkcopied: "निमन्त्रणाको लिङ्क प्रतिलिपि गरियो",
    tipsShare: "सुझावहरू: आफ्ना साथीहरूसँग निमन्त्रणा लिङ्क साझा गर्नुहोस्",
    thisMonthD: "यो महिनाको डेटा",
    formDay1: "day1 देखि day2 सम्म",
    hostGift: "होस्ट उपहार पोइन्ट",
    agentCommission: "एजेन्ट कमिसन",
    currentLevel: "हालको स्तर",
    commissionRateOf: "एजेन्टहरूको आयको कमिसन दर",
    baseSalary: "आधार वेतन",
    stillNeed: "अझै चाहिन्छ",
    toReach: "पुग्न",
    reachedthe: "विज्ञापन कार्य",
    advertisementTask: "डेटा जानकारी",
    dataOverview: "डेटा जानकारी",
    today: "आज",
    hostPoint: "होस्ट प्वाइंट",
    agentsPoints: "एजेन्ट प्वाइंट आय",
    thisMonth: "यो महिना",
    month: "महिना",
    lastMonth: "गत महिना",
    bdNumber: "BD संख्या",
    hostIncome: "होस्ट आय",
    todayIncome: "आजको आय",
    past30Days: "विगत ३० दिन",
    host: "होस्ट",
    country: "देश",
    level7: "स्तर / 7-दिन आय",
    pointIncome: "प्वाइंट आय",
    liveDuration: "लाइभ अवधि",
    joinTime: "सामेल हुने समय",
    state: "स्थिति",
    operation: "कार्य",
    bd: "BD",
    totalHosts: "कुल होस्ट आय",
    totalAgents: "कुल एजेन्ट आय",
    agent: "एजेन्ट",
    agentLevel: "एजेन्ट स्तर / कमिसन दर",
    commissionIncome: "कमिसन आय",
    showDirect: "Afno sagent haru matra dekhaune.Aja ko data samet chaina",
    excludingTodayData: "आजको डाटा समेटिएन",
    packages: "प्याकेजहरू",
    contents: "सामग्रीहरू",
    balance: "शेष",
    release: "जारी गर्नुहोस्",
    issue: "जारी गर्नुहोस्",
    createBd: "BD सिर्जना गर्नुहोस्",
    times: "पटक",
    authorizeCs: "CS लाई अधिकार दिनुहोस्",
    giftTo: "प्रयोगकर्तालाई उपहार दिनुहोस्",
    bdCreation: "BD सिर्जना सीमा शेष",
    csAuthorization: "CS अधिकार कोटा शेष",
    giftName: "उपहारको नाम",
    giftContents: "उपहार सामग्री",
    check: "जाँच गर्नुहोस्",
    cancel: "रद्द गर्नुहोस्",
    tip: "टिप",
    recipientsVip:
      "प्राप्तकर्ताको VIP स्तरले उपहार प्याकेज सीमा भन्दा बढी छ। यस उपहारका VIP सुविधाहरू अक्षम पारिनेछ। निश्चित रूपमा जारी राख्नुहुन्छ?",
    confirm: "पुष्टि गर्नुहोस्",
    authorize: "अधिकार दिनुहोस्",
    inviteBy: "प्रयोगकर्ता ID द्वारा आमन्त्रित गर्नुहोस्",
    invite: "आमन्त्रण गर्नुहोस्",
    inviteLink: "आमन्त्रण लिङ्क",
    copy: "प्रतिलिपि गर्नुहोस्",
    success: "सफल",
    pleaseCheck: "कृपया प्रयोगकर्ता ID जाँच गर्नुहोस्",
    totalGift:
      "सबै होस्टहरूको कुल उपहार आय (बाहेक र्याङ्किङ, कार्यहरू जस्ता प्लेटफर्म पुरस्कारहरू), सब-एजेन्सीहरूको उपहार आय समावेश गर्दछ।",
    totalAgentsCom:
      "आफ्नो होस्ट आयबाट एजेन्टहरूको कुल कमिसन, सब-एजेन्टहरूको कमिसन समावेश गर्दछ।",
    allAgent: "सबै एजेन्ट",
    directAgent: "प्रत्यक्ष एजेन्ट",
    indirectAgent: "अप्रत्यक्ष एजेन्ट",
    newUpgraded: "नयाँ स्तरोन्नत एजेन्ट",
    newS: "नयाँ S एजेन्टहरू",
    newB: "नयाँ B एजेन्टहरू",
    newC: "नयाँ C एजेन्टहरू",
    expectedReward: "अपेक्षित पुरस्कार",
    newA: "नयाँ A एजेन्टहरू",
    agencyLevel: "एजेन्सी स्तर",
    nickname: "उपनाम",
    editNicknameTip:
      "तपाईं हरेक महिना एक पटक निःशुल्क एजेन्सी नाम परिवर्तन गर्न सक्नुहुन्छ",
    enterNewNickname: "कृपया नयाँ उपनाम प्रविष्ट गर्नुहोस्",
    nicknameUpdateSuccess: "उपनाम सफलतापूर्वक अपडेट गरियो",
    cannotEditNickname: "उपनाम सम्पादन गर्न असमर्थ",
    cannotEditTip:
      "तपाईं तपाईंको उपनाम निःशुल्क एक पटक मात्र सम्पादन गर्न सक्नुहुन्छ। उपनाम परिमार्ज गर्न ग्राहक सेवासँग सम्पर्क गर्नुहोस्।",
    alreadyChangedTip:
      "तपाईं यो महिना एजेन्सी नाम परिवर्तन गरिसक्नुहुन्छ। अतिरिक्त परिवर्तनहरूको लागत ८,०० सिक्का छ।",
    payAndSave: "तिर्नुहोस् र बचत गर्नुहोस्",
    upgradeDate: "अपग्रेड मिति",
    bdPolicy: "BD नीति",
    agencyDetail: "एजेन्सी विवरण",
    agency: "एजेन्सी",
    hostCommission: "होस्ट कमिसन",
    last6Days: "पछिल्ला ६ दिन",
    giftIncome: "उपहार आय",
    mins: "मिनेट",
    agencyCenter: "एजेन्सी केन्द्र",
    myIncome: "mero aaja ko aay",
    totalHost: "kull host point",
    overview: "जानकारी",
    hostPoints: "host point",
    myHosts: "mero host point",
    subagentHost: "sub-agent host point",
    subagencyNumber: "sub-agency sankhya",
    otherIncome: "anya aay",
    contactAdmin: "admin sanga samparka garnuhos",
    whatsapp: "व्हाट्सएप",
    bdCenter: "BD Kendra",
    copySuccess: "safal bhayō",
    pleaseInput: "कृपया रिचार्ज रकम प्रविष्ट गर्नुहोस्, न्यूनतम 10",
    agencyPolicy: "एजेन्सी नीति",
    agencyCommission: "एजेन्सी कमिसन",
    agencyCommission2:
      "एजेन्सी कमिसन = कमिसन दर × सबै होस्टहरूको कुल उपहार आय (बाहेक र्याङ्किङ, कार्यहरू जस्ता प्लेटफर्म पुरस्कारहरू)",
    excludingPlatform:
      "(बाहेक र्याङ्किङ, कार्यहरू जस्ता प्लेटफर्म पुरस्कारहरू)",
    agencyCommissionCalculation: "एजेन्सी कमिसन गणना",
    level: "स्तर",
    pointsTarget: "प्वाइंट लक्ष्य (विगत ३० दिन)",
    points10000: "10,000 प्वाइंट = 1 USD (M= million)",
    note1:
      "नोट १: कुल वैध आय = तपाईंको एजेन्सी आय + तपाईंका सब-एजेन्सीहरूको प्रत्येक तहको आय",
    note2:
      "नोट २: होस्टले उपहार प्राप्त गर्दा, एजेन्सी कमिसन वास्तविक समयमा जम्मा गरिनेछ।",
    note3:
      "नोट ३: न्यूनतम निकासी रकम १० अमेरिकी डलर हो, र निकासी रकम १० को गुणन हुनुपर्छ (उदाहरण: १० USD, २० USD, ३० USD)।",
    subagencycommission: "सब-एजेन्सी कमिसन",
    theMain:
      "मुख्य एजेन्सीले प्रत्येक तहका सब-एजेन्सीहरू (T1, T2, T3, T4, ... Tn) को आयबाट कमिसन कमाउन सक्छ, अधिकतम कमिसन दर १६% छ।",
    forExample: "उदाहरण को लागि -",
    agencyA: "Agency A le Agency B ra Agency C lai nimantrana garcha.",
    agencyB: "Agency B le Agency D ra Agency E lai nimantrana garcha.",
    agencyC: "Agency C le Agency F lai nimantrana garcha.",
    noteFigures:
      "(नोट: कोष्ठकभित्रका संख्याले प्रत्येक एजेन्सीअन्तर्गतका होस्टहरूको आय प्रतिनिधित्व गर्दछ)।",
    thusWe:
      "यसैले, हामी एजेन्सी A देखि एजेन्सी F सम्मको कुल वैध आय र कमिसन दर गणना गर्न सक्छौं।",
    totalValid:
      "कुल वैध आय = तपाईंको एजेन्सीको आय + सब-एजेन्सीहरूको प्रत्येक तहको आय",
    aTotal:
      "A कुल वैध आय = A + B + C + D + E + F = 10M + 20M + 70M + 20M + 30M +80M = 230M (२०% कमिसन दर)",
    bTotal: "B कुल वैध आय = B + D + E = 20M + 20M + 30M = 70M (१६% कमिसन दर)",
    cTotal: "C कुल वैध आय = C + F = 70M + 80M =150M (२०% कमिसन दर)",
    dTotal: "D कुल वैध आय =20M (१२% कमिसन दर)",
    eTotal: "E कुल वैध आय =30M (१२% कमिसन दर)",
    fTotal: "F कुल वैध आय =80M (१६% कमिसन दर)",
    subagencyCommission:
      "सब-एजेन्सी कमिसन = (मुख्य एजेन्सी कमिसन दर - सब-एजेन्सी कमिसन दर) × सब-एजेन्सीको कुल वैध आय",
    agencyAC: "एजेन्सी {A} बाट एजेन्सी {B} प्राप्त कमिसन",
    thereforeAgency:
      "यसकारण, एजेन्सी {A} ले सब-एजेन्सीहरूबाट प्राप्त गरेको कुल कमिसन",
    sinceAgency:
      "Agency D, E, ra F sanga sub-agency nahune bhayekale, tiniharu le sub-agency commission kamna sakdainan।",
    seniorPolicy: "वरिष्ठ नीति",
    nomore: "कुनै थप डाटा छैन",
    active: "सक्रिय",
    disabled: "अक्षम पारिएको",
    deleted: "मेटाइएको",
    lastLogintime: "अन्तिम लगइन समय",
    onmic: "आज माइकमा",
  },
  sellerCoin: {
    detailsOf: "निकासी विवरण",
    fundsSent: "निधि पठाइयो",
    transfer: "स्थानान्तरण",
    totalIncome: "कुल आय",
    orderIncome: "अर्डर आय",
    estimatedReward: "अनुमानित पुरस्कार",
    amount: "रकम",
    applicantId: "आवेदक आईडी",
    applicantName: "आवेदकको नाम",
    orderId: "आदेश आईडी",
    uploadScreenshot: "स्क्रिनशट अपलोड गर्नुहोस्",
    ensureWithdrawal:
      "निकासी सफल भएको सुनिश्चित गर्नुहोस्, त्यसपछि स्क्रिनशट अपलोड गर्नुहोस् र तलको बटन क्लिक गरेर आवेदकलाई सूचना दिनुहोस्।",
    remain: "बाँकी",
    pleasePay:
      "तुरुन्तै तिर्नुहोस् र रसिद अपलोड गर्नुहोस्। यदि समय सीमा नाघ्नुभयो भने, अर्डरको भुक्तानी योग्यता रद्द हुनेछ।",
    youCan: "तपाईंले प्रति दिन ५,००० सम्म आमन्त्रित अंक कमाउन सक्नुहुन्छ।",
    pleaseComplete: "कृपया समयमै निकासी पूरा गर्नुहोस् ",
    unableTo: "तिर्न असमर्थ, अस्वीकार",
    notifyThe: "आवेदकलाई सूचना दिनुहोस्",
    youCanGet:
      "अर्डरहरू समयमै संभाल्नुभएमा 1%-3% थप बोनस प्राप्त गर्न सक्नुहुन्छ।",
    ifYou:
      "अर्डरहरू ३० मिनेटभित्र संभाल्नुभएमा ३% बोनस प्राप्त गर्न सक्नुहुन्छ।",
    egThe:
      "उदाहरण: ९०००० प्वाइंटको अर्डर, तपाईंले ३० मिनेटभित्र यसलाई संभाल्नुभयो भने, ३% बोनस प्राप्त गर्न सक्नुहुन्छ, जुन ९०००० × ३% = २७०० प्वाइंट हो।",
    gotIt: "थाहा भयो",
    pleaseUpload: "कृपया तस्विर अपलोड गर्नुहोस्",
    detail: "विवरण",
    balance: "Balance",
    exchange: "विनिमय",
    all: "सबै",
    recharge: "रिचार्ज",
    official: "आधिकारिक",
    exchangeDetail: "विनिमय विवरण",
    coinSeller: "सिक्का विक्रेता",
    levelUp: "स्तर माथि",
    currentLevel: "हालको स्तर",
    myBalance: "मेरो शेष",
    details: "विवरण",
    paymentMethod: "भुक्तानी विधि",
    myOrder: "मेरो आदेश",
    paymentMenthod: "भुक्तानी विधि",
    acceptingOrders: "आदेश स्वीकार गर्दै",
    unavailable: "उपलब्ध छैन",
    greetingMessage: "अभिवादन सन्देश सेटिङ",
    serviceUnavailable: "सेवा उपलब्ध छैन",
    thisFeature:
      "यो सुविधा अस्थायी रूपमा लक गरिएको छ। कृपया सहयोगको लागि ग्राहक सहयोगसँग सम्पर्क गर्नुहोस्।",
    editMessage: "सन्देश सम्पादन गर्नुहोस्",
    customizeYour:
      "आफ्नो अभिवादन सन्देश अनुकूलित गर्नुहोस्। तपाइँ सिक्का रिचार्ज गर्ने बारेमा मद्दतकारी जानकारी समावेश गर्न सक्नुहुन्छ।",
    theMessage:
      "नयाँ प्रयोगकर्ताले तपाइँसँग निजी च्याट सुरु गर्दा सन्देश स्वचालित रूपमा पठाइनेछ।",
    save: "बचत गर्नुहोस्",
    pleaseEnterMessge: "कृपया आफ्नो अभिवादन सन्देश प्रविष्ट गर्नुहोस्",
    salesMethod: "बिक्री विधि",
    user: "प्रयोगकर्ता",
    coinseller: "सिक्का विक्रेता",
    userId: "प्रयोगकर्ता आईडी",
    check: "जाँच गर्नुहोस्",
    coinAmount: "सिक्का रकम",
    pleaseEnter: "कृपया 1 को गुणनफल प्रविष्ट गर्नुहोस्",
    enterAt: "कम्तिमा 100 प्रविष्ट गर्नुहोस्, 1 को गुणनफलमा",
    transferDetails: "स्थानान्तरण विवरण",
    recommendSeller: "विक्रेता सिफारिस गर्नुहोस्",
    recent30Day: "हालको 30-दिने सिक्का बिक्री",
    whatsapp: "WhatsApp",
    chat: "च्याट",
    yourCountry: "तपाइँको देशमा हाल कुनै उपलब्ध सिक्का विक्रेता छैनन्।",
    pleaseContact: "कृपया ग्राहक सहयोगसँग सम्पर्क गर्नुहोस्।",
    customerSupport: "ग्राहक सहयोग",
    contact: "सम्पर्क गर्नुहोस्",
    customRecharge: "कस्टम रिचार्ज",
    rechargeDetails: "रिचार्ज विवरण",
    myPoints: "मेरो अंक",
    todayRemaining: "आज बाँकी कोटा",
    customExchange: "कस्टम एक्सचेंज",
    exchangeDetails: "विनिमय विवरण",
    rechargeRules: "रिचार्ज नियम",
    sellerLevel: "विक्रेता स्तर",
    proportion: "अनुपात",
    levelRequirement: "स्तर आवश्यकता",
    beginner: "सुरुवाती",
    singleRecharge: "एकल रिचार्ज",
    standard: "मानक",
    senior: "वरिष्ठ",
    exchangeRules: "विनिमय नियम",
    note: "Note",
    seniorCoin:
      "वरिष्ठ विक्रेताले दैनिक पूर्ण दरमा {point} अंकसम्म बदल्न सक्छन्। {point} पछि:",
    beginnerSeller: "सुरुवाती विक्रेता",
    standardSeller: "मानक विक्रेता",
    seniorSeller: "वरिष्ठ विक्रेता",
    cancel: "Cancel",
    pleaseInput: "Please input the recharge amount, minimum 10",
    pleaseInput2: "कृपया रिचार्ज रकम प्रविष्ट गर्नुहोस्, 100K को गुणनफल",
    confirmation: "पुष्टि",
    userName: "प्रयोगकर्ता नाम",
    theUser: "प्रयोगकर्ता कालोसूचीमा राखिएको छ",
    enterAmount: "रकम प्रविष्ट गर्नुहोस्",
    pleaseInput3: "कृपया रकम प्रविष्ट गर्नुहोस्",
    theAmount: "रकम 100000 को गुणनफल हुनुपर्छ",
    pleaseInput4: "कृपया रकम प्रविष्ट गर्नुहोस् वा चयन गर्नुहोस्",
    pleaseSelect: "कृपया बिक्री विधि चयन गर्नुहोस्",
    pleaseInput5: "कृपया userId प्रविष्ट गर्नुहोस्",
    atLeast: "कम्तिमा 100K सिक्का स्थानान्तरण गर्न ~",
    pleaseSelect2: "कृपया भुक्तानी विधि चयन गर्नुहोस्",
    minimum: "न्यूनतम",
    theAmount3: "रकम 1 को गुणनफल हुनुपर्छ",
    lessThan: "100000 भन्दा कम वा बराबर",
    orders: "आदेशहरू",
    applicant: "आवेदक",
    method: "विधि",
    withdrawTime: "निकासी समय",
    viewDetail: "विवरण हेर्नुहोस्",
    toBe: "पुष्टि हुन बाँकी",
    toBePaid: "भुक्तानी हुन बाँकी",
    toBeCompleted: "पूरा हुन बाँकी",
    completed: "पूरा भयो",
    abnormal: "असामान्य",
    refused: "Refused",
    confirmationTimeout: "पुष्टि समय सीमा समाप्त",
    paymentTimeout: "भुक्तानी समय सीमा समाप्त",
    binance: "बिनेंस",
    scanThe: "भुक्तानी गर्न QR कोड स्क्यान गर्नुहोस्",
    quantity: "मात्रा",
    orderAmount: "आदेश रकम",
    date: "मिति",
    payNow: "अबै भुक्तानी गर्नुहोस्",
    payment: "भुक्तानी",
    pleasePay2: "कृपया निम्न तरिकाले भुक्तानी गर्नुहोस्",
    chainName: "श्रृंखला नाम",
    contractAddress: "ठेक ठेगाना",
    theAbove: "माथिको ठेगाना यो रिचार्जको लागि मात्र मान्य छ",
    copy: "Copy",
    notice: "सूचना",
    pleaseTransfer:
      "कृपया Binance को शुल्कको लागि थप 1 USDT स्थानान्तरण गर्नुहोस्। यसो गर्न नसक्दा तपाइँको सिक्का रिचार्ज ढिलो हुन सक्छ।",
    paymentsMust:
      "भुक्तानीहरू 0.5 घण्टाभित्र पूरा गर्नुपर्छ, वा प्लेटफर्म कुनै पनि समस्याको लागि जिम्मेवार हुने छैन।",
    add: "थप्नुहोस्",
    confirmTo: "यो भुक्तानी विधि मेटाउन पुष्टि गर्नुहोस्",
    countryCurrency: "देश र मुद्रा प्रकार",
    selectPayment: "तपाइँले रेमिट गर्न सक्ने भुक्तानी विधि चयन गर्नुहोस्",
    coinsSeller: "सिक्का विक्रेता नियम",
    standrd: "मानक",
    salesMethods: "बिक्री विधिहरू",
    coinsellerRules: "सिक्का विक्रेता नियम",
    whenApplying:
      "सिक्का विक्रेताको स्थितिमा स्तरोन्नतिको लागि आवेदन दिंदा, कुनै जम्मा आवश्यकता हुँदैन सिक्का विक्रेता स्तर स्तरोन्नति गर्न १-पटक रिचार्ज मात्र चाहिन्छ। यदि तपाइँ सिक्का विक्रेताको रूपमा आफ्नो पदबाट राजीनामा दिन छनौट गर्नुहुन्छ भने, तपाइँको हालको सिक्का विक्रेताको भूमिका समाप्त हुनेछ।",
    youCanReplenish:
      "तपाइँ आफ्नो खाता सीधै USDT, Epay वा अर्को सिक्का विक्रेताको मार्फत पनि पूर्ति गर्न सक्नुहुन्छ।",
    fraudulentActivities:
      "Hala प्लेटफर्म भित्र कपटपूर्ण गतिविधिहरू कडाईं निषेध गरिएको छ।",
    anyViolations: "कुनै पनि उल्लंघनले सिक्का विक्रेताको खाता समाप्त हुनेछ।",
    allRights: "सबै अधिकार Hala द्वारा सुरक्षित छन्।",
    transferDetail: "स्थानान्तरण विवरण",
  },
  centerHost: {
    baseSalary: "आधार वेतन",
    invitation: "निम्तो",
    tasks: "कार्यहरू",
    other: "अन्य",
    consume: "खपत",
    giftIncome: "Gift Income",
    received: "प्राप्त भयो",
    from: "बाट",
    luckyGift: "भाग्यशाली उपहार",
    hostCenter: "होस्ट केन्द्र",
    noAgent: "कुनै एजेन्ट छैन",
    last7: "अन्तिम ७ दिन",
    hourlyIncome: "प्रति घण्टा आय",
    toReach: "to reach",
    rules: "नियम",
    pointsOverview: "अंक अवलोकन",
    totalIncome: "कुल आय",
    gifts: "उपहारहरू",
    workDetail: "कार्य विवरण",
    liveDuration: "Live Duration",
    mins: "mins",
    todaysLive: "आजको लाइव रेकर्ड",
    dailyStatistics: "दैनिक तथ्याङ्क",
    startTime: "सुरुवात समय",
    endTime: "अन्त्य समय",
    duration: "अवधि",
    points: "अंकहरू",
    date: "Date",
    giftPoints: "उपहार अंक",
    removeBinding: "बन्धन हटाउनुहोस्",
    thisAction2:
      "यो कार्यले तपाइँलाई {agentName} बाट अबन्धन गर्नेछ। कृपया अबन्धन जारी राख्न चाहनुहुन्छ कि भनेर पुष्टि गर्नुहोस्",
  },
  bombRule: {
    afterThe:
      "कोठामा विस्फोट मान निश्चित रकममा पुगेपछि, उपहार बम कोठामा देखा पर्नेछ।",
    oneCoins: "कोठामा प्राप्त 1 सिक्का = 1 विस्फोट मान",
    itWill:
      "आवश्यकता पूरा गरेपछि यो स्वचालित रूपमा विस्फोट हुनेछ, र कोठा मालिकले सम्बन्धित सुनको सिक्का पुरस्कार प्राप्त गर्नेछ।",
  },
  descriptionLevel: {
    wealth: "सम्पत्ति",
    charm: "आकर्षण",
    wealthValue: "सम्पत्ति मान",
    charmValue: "आकर्षण मान",
    needTo: "आवश्यक छ",
    send: "पठाउनुहोस्",
    receive: "प्राप्त गर्नुहोस्",
    forThe: "स्तरोन्नतिको लागि",
    theRich: "धनी स्तर तपाइँले रिचार्ज गर्नुभएको सिक्काहरूद्वारा गणना गरिन्छ",
    theCharm:
      "आकर्षण स्तर तपाइँले प्राप्त गर्नुभएको सिक्काहरूको संख्यामा आधारित गणना गरिन्छ",
    LevelLabel: "स्तर लेबल",
    level: "Level",
    levelLogo: "स्तर लोगो",
  },
  gameRank: {
    gameRank: "खेल र्याङ्क",
    rules: "Rules",
    thisWeek: "यो हप्ता",
    lastWeek: "गत हप्ता",
    agentGaming: "एजेन्ट गेमिङ आय र्याङ्किङ",
    rankingRewards: "र्याङ्किङ पुरस्कार",
    rankingIs:
      "र्याङ्किङ एजेन्टको कोठा र यसको उप-कोठाहरूमा प्रयोगकर्ताहरूको कुल बेटिङ टर्नओभरमा आधारित छ।",
    hostRoom: "होस्ट कोठा आय र्याङ्किङ",
    rankingIs2: "र्याङ्किङ होस्टको कोठामा उत्पन्न कुल गेमिङ आयमा आधारित छ।",
    notes: "टिप्पणीहरू",
    eventDuration:
      "घटना अवधि: प्रत्येक पात्रो सप्ताह। पुरस्कारहरू मात्र वितरण गरिन्छ यदि",
    rewardsAre:
      "Rewards are distributed only if the corresponding revenue requirements are met.",
    allRewards:
      "All rewards will be issued within 1-2 working days after the event ends.",
    halaReserves: "Hala ले यस घटनाको अन्तिम व्याख्याको अधिकार सुरक्षित राख्छ।",
    rewardsDetail: "पुरस्कार विवरण",
    decorationsPreview: "सजावट पूर्वावलोकन",
  },
  gameLegacyHall: {
    surpriseLucky: "आश्चर्यजनक भाग्यशाली ब्याग",
    dailyPlayers:
      "दैनिक खेलाडीहरूले अनियमित सिक्काको लागि अर्को दिन भाग्यशाली ब्याग खोल्न सक्छन्।",
    eventRule: "घटना नियम",
    usersSpending:
      "घटना खेलहरूमा प्रयोगकर्ताहरूको खर्च तिनीहरूको र्याङ्किङ स्कोरमा गणना हुनेछ。",
    thePlatform:
      "प्लेटफर्मले हरेक ४ घण्टामा घटना खेलहरू घुमाउनेछ, प्रत्येक रोटेसनमा ४ वटा फरक खेलहरू समावेश गरिनेछ。",
    theTop:
      "दैनिक शीर्ष ३ खेलाडीहरूले फ्रेम र सिक्का पुरस्कार प्राप्त गर्नेछन्。",
    theTop2:
      "साप्ताहिक शीर्ष १० खेलाडीहरूले फ्रेम र सिक्का पुरस्कार प्राप्त गर्नेछन्।",
    usersWho:
      "प्रत्येक दिन घटना खेलहरूमा सहभागी हुने प्रयोगकर्ताहरूले अनियमित सिक्का प्राप्त गर्न अर्को दिन भाग्यशाली ब्याग खोल्न सक्छन्। घटना खेलहरूमा तपाइँले जतिसुकै बढी खर्च गर्नुहुन्छ, ततिसुकै बढी सिक्का प्राप्त गर्न सक्नुहुन्छ।",
    behindPrevious: "अघिल्लो पछाडि",
    thisWeek: "This Week",
    lastWeek: "Last Week",
    countdown: "काउन्टडाउन:",
    days: "दिनहरू",
    winOver: "माथि जित्नुहोस्",
    coinsfrom: "एक दिनमा खेलबाट सिक्का",
    earnOver: "माथि कमाउनुहोस्",
    coinsWitdh: "फिर्ता दर सम्म",
    fromOneDay: "एक दिनमा",
    game: "खेल",
    fromA: "एकल बेटबाट",
    inthisWeek: "यस हप्तामा",
    earnUp: "सम्म कमाउनुहोस्",
    inAsingle: "एक दिनमा",
    eventRules: "घटना नियमहरू",
    participateIn: "भोलि ठूलो भाग्यशाली ब्याग दावी गर्न खेलमा सहभागी हुनुहोस्",
    youDid:
      "तपाइँले सिक्का पुरस्कार प्राप्त गर्नुभएन। खेलमा सहभागी हुनुहोस् र तपाइँ भोलि भाग्यशाली ब्याग दावी गर्न जारी राख्न सक्नुहुन्छ।",
    participateIn2:
      "खेलमा सहभागी हुनुहोस् र तपाइँ भोलि भाग्यशाली ब्याग दावी गर्न जारी राख्न सक्नुहुन्छ।",
    topDaily: "शीर्ष दैनिक सिक्का विजेता",
    topPayout: "शीर्ष भुक्तान दर विजेता",
    topCoins: "साप्ताहिक एक राउण्डमा शीर्ष सिक्का विजेता",
    topPayout2: "साप्ताहिक एक राउण्डमा शीर्ष भुक्तान दर विजेता",
    topWeekly: "शीर्ष साप्ताहिक सिक्का विजेता",
    historicalTop: "ऐतिहासिक एक दिनमा शीर्ष सिक्का विजेता",
    historicalTop2: "ऐतिहासिक एक दिनमा शीर्ष भुक्तान दर विजेता",
    historicalTop3: "ऐतिहासिक एक राउण्डमा शीर्ष सिक्का विजेता",
    historicalTop4: "ऐतिहासिक एक राउण्डमा शीर्ष भुक्तान दर विजेता",
    historicalTop5: "ऐतिहासिक एक हप्तामा शीर्ष सिक्का विजेता",
    gameReward: "खेल पुरस्कार",
    usersSpending2:
      "घटना खेलहरूमा प्रयोगकर्ताहरूको खर्च तिनीहरूको र्याङ्किङ स्कोरमा गणना हुनेछ。",
    theTop3:
      "दैनिक शीर्ष ३ खेलाडीहरूले फ्रेम र सिक्का पुरस्कार प्राप्त गर्नेछन्。",
    theTop4:
      "साप्ताहिक शीर्ष १० खेलाडीहरूले फ्रेम र सिक्का पुरस्कार प्राप्त गर्नेछन्।",
    usersWho2:
      "प्रत्येक दिन घटना खेलहरूमा सहभागी हुने प्रयोगकर्ताहरूले अनियमित सिक्का प्राप्त गर्न अर्को दिन भाग्यशाली ब्याग खोल्न सक्छन्। घटना खेलहरूमा तपाइँले जतिसुकै बढी खर्च गर्नुहुन्छ, ततिसुकै बढी सिक्का प्राप्त गर्न सक्नुहुन्छ।",
    coins: "सिक्का",
    flameRider: "ज्वाला सवार",
    sportCar: "स्पोर्ट कार",
    captainMeow: "क्याप्टेन म्याउ",
    profileFrame: "प्रोफाइल फ्रेम",
  },
  gold: {
    coinsDetail: "सिक्का विवरण",
    coinBalance: "सिक्का शेष",
    all: "ALL",
    sendGifts: "उपहार पठाउनुहोस्",
    purchaseItems: "वस्तुहरू खरीद गर्नुहोस्",
    games: "खेलहरू",
    exchange: "Exchange",
    recharge: "Recharge",
    activeReword: "गतिविधि पुरस्कारहरू",
  },
  integral: {
    all: "All",
    cashOut: "निकासी",
    transfer: "Transfer",
    orderId: "Order ID",
    paymentMenthod: "Payment Menthod",
    withdrawalTime: "निकासी समय",
    pointsAmount: "अंक रकम",
    depositAmount: "जम्मा रकम",
    coinsAmount: "सिक्का रकम",
    transferTo: "मा स्थानान्तरण गर्नुहोस्",
    normal: "सामान्य",
    pending: "पेन्डिङ",
    success: "Success",
    failed: "असफल",
    points: "Points",
    pointsBalance: "अंक शेष",
    frozenPoints: "जम्मा अंक",
    details: "विवरण",
    exchange: "Exchange",
    currencyType: "मुद्रा प्रकार",
    paymentMethod: "Payment method",
    pointsAmount2: "नगदा बाहिर निकाल्नको लागि अंक रकम",
    enterA: "100,000 को गुणनफल प्रविष्ट गर्नुहोस् (न्यूनतम 200,000)",
    enterA2: "100000 को गुणनफल प्रविष्ट गर्नुहोस्",
    accountInformation: "खाता जानकारी",
    withdraw: "निकासी गर्नुहोस्",
    amount: "रकम",
    exchangeRate: "विनिमय दर",
    exchangePoints: "विनिमय अंक",
    enterUserId: "प्रयोगकर्ता आईडी प्रविष्ट गर्नुहोस्",
    check: "Check",
    fee: "शुल्क",
    theAgency: "एजेन्सीले प्राप्त गर्नेछ",
    transferFee: "स्थानान्तरण शुल्क- 2%। न्यूनतम स्थानान्तरण ≥ १००,००० अंक।",
    clickTransfer:
      "तपाइँका एजेन्टहरूलाई सम्बन्धित अंक स्थानान्तरण गर्न स्थानान्तरण बटन क्लिक गर्नुहोस्",
    afterThe2: "स्थानान्तरण समाप्त भएपछि, यसलाई रद्द वा फिर्ता गर्न सकिँदैन।",
    transferPoints: "अंक स्थानान्तरण गर्नुहोस्",
    recommendedMethod: "सिफारिस गरिएको विधि",
    lowerFees: "कम शुल्क र २४ घण्टाभित्र समीक्षा गरिन्छ",
    paymentPassword: "भुक्तानी पासवर्ड सेट गरिएको छैन",
    cashOut2:
      "नगदा बाहिर निकाल्न र एक्सचेजहरूले भुक्तानी पासवर्ड प्रमाणीकरण आवश्यक पर्दछ। कृपया पहिले आफ्नो भुक्तानी पासवर्ड सेट अप गर्नुहोस्।",
    cancel: "Cancel",
    goTo: "सेटिङहरूमा जानुहोस्",
    youHave:
      "तपाईंले ५ पटक असफल प्रयास गरिसक्नुभएको छ। एउटा थप असफल प्रयासले तपाईंको खाता फ्रिज हुनेछ। यदि तपाईंले आफ्नो पासवर्ड बिर्सनुभएको छ भने, कृपया यसलाई रिसेट गर्नुहोस्。",
    inputIncorrect:
      "धेरै पटक गलत पासवर्ड इनपुट गर्नुभयो। तपाइँको खाता फ्रिज गरिएको छ, कृपया पछि फेरी प्रयास गर्नुहोस्",
    verify: "प्रमाणित गर्नुहोस्",
    gotIt: "Got it",
    pointsInfo: "अंक जानकारी",
    whenA:
      "जब एक प्रयोगकर्ताले Google मार्फत रिचार्ज गरिएको सिक्का प्रयोग गरेर तपाइँलाई उपहार पठाउँछ, तपाइँले प्राप्त गर्नुभएको अंकहरू उपलब्ध हुनुभन्दा ७ दिन अगाडि फ्रिज हुनेछन्। यदि प्रयोगकर्ताले फिर्ता गर्न अनुरोध गर्छ भने, ती अंकहरू कटौती गरिनेछन्। कृपया प्लेटफर्म नियमहरू पालना गर्नुहोस् र कुनै पनि उल्लंघनबाट टाढा रहनुहोस्।",
    frozenPointsAre: "जम्मा अंकहरू कुल अंक शेषमा समावेश छन्",
    theUser2: "प्रयोगकर्ता कालोसूचीमा राखिएको छ",
    successfulWithdrawal: "सफल निकासी",
    withdrawalAmount: "निकासी रकम",
    theFunds: "रकम २४ घण्टाभित्र आइपुग्नेछ",
    pleaseEnter2: "कृपया पासवर्ड प्रविष्ट गर्नुहोस्",
    passwordIncorrect: "पासवर्ड गलत",
    theAmount4: "रकम 100000 को गुणनफल हुनुपर्छ",
    pleaseEnter3: "कृपया प्रयोगकर्ता आईडी प्रविष्ट गर्नुहोस्",
    pleaseEnter4: "कृपया सही प्रयोगकर्ता आईडी प्रविष्ट गर्नुहोस्",
    pleaseEnter5: "कृपया रकम प्रविष्ट गर्नुहोस्",
    minimumTransfer: "न्यूनतम स्थानान्तरण ≥ १००,००० अंक",
    pleaseSelect3: "कृपया विधि चयन गर्नुहोस्",
    minimum: "minimum",
    theAmount5: "रकम भन्दा कम हुनुपर्छ",
    illegalInput: "अवैध इनपुट",
    pleaseEnter6: "कृपया खाता जानकारी प्रविष्ट गर्नुहोस्",
  },
  invite: {
    inviteGame: "खेल प्रयोगकर्ता आमन्त्रित गर्नुहोस्",
    currentRebate: "हालको रिबेट",
    need: "आवश्यक छ",
    toProgress: "अर्को स्तरमा अगाडि बढ्न",
    gameReward: "Game Reward",
    referralData: "सिफारिस डाटा",
    referralList: "सिफारिस सूची",
    date: "Date",
    gameBets: "खेल बेटहरू",
    inviteRewards: "आमन्त्रण पुरस्कार",
    viewMore: "थप हेर्नुहोस्",
    inviteFriends: "साथीहरूलाई आमन्त्रित गर्नुहोस्",
    myReward: "मेरो पुरस्कार",
    totalRewards: "कुल पुरस्कार",
    dailyReward: "दैनिक पुरस्कार",
    inviteRules: "आमन्त्रण नियम",
    yourRebate:
      "तपाइँको रिबेट दर अन्तिम ३० दिनमा तपाइँको कुल वैध बेटहरूमा निर्भर गर्दछ。",
    totalValid2:
      "कुल वैध बेट = तपाइँको आफ्नै बेट + तपाइँले आमन्त्रित गर्नुभएका प्रयोगकर्ताहरूको प्रत्येक तहको आफ्नै बेट",
    rebateFrom:
      "Tier-1 आमन्त्रित प्रयोगकर्ताबाट रिबेट = तिनीहरूको आफ्नै बेट × तपाइँको रिबेट दर",
    rebateFrom2:
      "Tier-2 आमन्त्रित प्रयोगकर्ताबाट रिबेट = तिनीहरूको आफ्नै बेट × (तपाइँको रिबेट दर - Tier-1 रिबेट दर)",
    ifThe:
      "यदि Tier-2 आमन्त्रित प्रयोगकर्ताले Tier-3 प्रयोगकर्ता आमन्त्रित गर्छ भने, यसले उसको कुल वैध बेटहरू बढाउन सक्छ, तर उसले Tier-3 बाट रिबेट प्राप्त गर्न सक्दैन।",
    example: "उदाहरण",
    tier1:
      "Tier-1 आमन्त्रित - तपाइँद्वारा प्रत्यक्ष रूपमा आमन्त्रित गरिएकाहरूबाट रिबेट कसरी गणना गर्ने?",
    asRebate:
      "B, C र D बाट A को रिबेट = (B को आफ्नै बेट + C को आफ्नै बेट + D को आफ्नै बेट) × A को रिबेट दर =",
    bsRebate:
      "E र F बाट B को रिबेट = (E को आफ्नै बेट + F को आफ्नै बेट) × B को रिबेट दर =",
    csRebate: "G बाट C को रिबेट = G को आफ्नै बेट × C को रिबेट दर =",
    tier2:
      "Tier-2 आमन्त्रित - तपाइँद्वारा अप्रत्यक्ष रूपमा आमन्त्रित गरिएकाहरूबाट रिबेट कसरी गणना गर्ने?",
    asRebate2:
      "E र F बाट A को रिबेट = (A को रिबेट दर - B को रिबेट दर) × (E को आफ्नै बेट + F को आफ्नै बेट) =",
    asRebate3:
      "G बाट A को रिबेट = (A को रिबेट दर - C को रिबेट दर) × G को आफ्नै बेट =",
    myInvitation: "मेरो आमन्त्रण",
    search: "Search",
    invitationTime: "आमन्त्रण समय",
    inviteHost: "Invite Host",
    inviteA: "होस्ट आमन्त्रित गर्नुहोस्, प्रत्येक सम्म",
    todayRewards: "आजका पुरस्कार",
    rewardDetail: "पुरस्कार विवरण",
    creatorRewards: "सर्जक पुरस्कार वालेट",
    collect: "संग्रह गर्नुहोस्",
    invitationDate: "आमन्त्रण मिति",
    hostPolicy: "होस्ट नीति",
    halaReserves2:
      "Hala ले माथिको नीतिहरूको अन्तिम व्याख्याको अधिकार सुरक्षित राख्छ।",
  },
  listContribution: {
    contributiont: "योगदान",
    host: "Host",
    wealth: "Wealth",
    today: "Today",
    yesterday: "हिजो",
    game: "Game",
    gift: "उपहार",
    hostEarnings: "होस्ट आय",
  },
  missionRule: {
    hostPolicy: "Host Policy",
    halaReserves3:
      "Hala ले माथिको नीतिहरूको अन्तिम व्याख्याको अधिकार सुरक्षित राख्छ।",
  },
  purchase: {
    recharge: "Recharge",
    userId: "User ID",
    confirm: "Confirm",
    switchAccount: "खाता परिवर्तन गर्नुहोस्",
    countryRegion: "देश/क्षेत्र",
    officialAgency: "आधिकारिक एजेन्सी रिचार्ज",
    ttOff: "२०% छुट",
    totalAmount: "कुल रकम",
    purchase: "खरीद गर्नुहोस्",
    pleaseComfirm: "कृपया प्रयोगकर्ता आईडी पुष्टि गर्नुहोस्",
    pleaseInput8: "कृपया प्रयोगकर्ता आईडी प्रविष्ट गर्नुहोस्",
    onlineService: "अनलाइन सेवा",
    dealOf: "अन्तिम ३० दिनको सौदा",
    recent30Day2: "हालको 30-दिने सिक्का बिक्री",
    paymentMethod: "Payment Method",
    whatsapp: "WhatsApp",
    chat: "Chat",
    yourCountry2: "तपाइँको देशमा हाल कुनै उपलब्ध सिक्का विक्रेता छैनन्।",
    pleaseContact2: "कृपया ग्राहक सहयोगसँग सम्पर्क गर्नुहोस्।",
    customerSupport: "customer support",
    contact: "Contact",
  },
  roomGiftRule: {
    eventRules: "Event Rules",
    treasureChest: "कोठामा उपहार दिएर खजाना चेस्टको प्रगति बढाइन्छ",
    whenThe: "चेस्ट कुञ्जीको प्रगति पट्टी भरेपछि, खजाना चेस्ट खोलिनेछ",
    afterThe3:
      ".स्तर ३ र स्तर ४ को खजाना चेस्टले आवश्यकता पूरा गरेपछि, तिनीहरू १ मिनेटको लागि लक गरिनेछ र स्वचालित रूपमा खोलिनेछ।",
    everyoneIn:
      "कोठामा भएका सबैजनासँग खजानाको छातीमा पुरस्कारहरू प्राप्त गर्ने मौका छ।",
    onceThe:
      "एकपटक खजानाको बाकस खोलिएपछि, प्रणालीले तपाईंको खातामा पुरस्कार जारी गर्न धेरै मिनेट लाग्न सक्छ। सुनका सिक्काहरू तपाईंको ब्यालेन्समा थपिनेछन् र पोशाक तपाईंको सूचीमा थपिनेछ।",
    theHigher:
      "खजानाको चेस्टको स्तर जति माथि हुन्छ, त्यसमा त्यति नै ठूलो पुरस्कार हुन्छ।",
    ifYou2:
      "यदि तपाईंलाई तपाईंको हालको भन्दा कम VIP स्तर भएको VIP को रूपमा छनोट गरिएको छ भने, VIP स्तर लागू हुनेछैन।",
    theProgress:
      "छाती कुञ्जीको प्रगति पट्टी हरेक दिन ००:०० (UTC+५:३०) मा रिसेट हुनेछ।",
  },
  share: {
    joinHala:
      "धेरै कमाईका अवसरहरू अनलक गर्न र एजेन्सीहरूको लागि अनुकूलित लाभ र पुरस्कारहरूको आनन्द लिन हालामा सामेल हुनुहोस्।",
    downloadTo: "साझेदार बन्न डाउनलोड गर्नुहोस्",
    joinHala2:
      "रमाइलो खेलहरू र अद्भुत पुरस्कारहरू जित्ने मौकाको लागि Hala मा सामेल हुनुहोस्।",
    downloadAnd: "डाउनलोड गर्नुहोस् र जित्न सुरु गर्नुहोस्",
    joinHala3:
      "Hala मा सामेल हुनुहोस् र आफ्नो होस्टिंग यात्रा सुरु गर्नुहोस्। दैनिक $३६ सम्मको बोनस कमाउनुहोस्!",
    inviteYou: "एजेन्सीमा सामेल हुन आमन्त्रित गर्दछु",
    downloadNow: "होस्टिङ सुरु गर्न अहिले नै डाउनलोड गर्नुहोस्",
    comeWith: "हालामा च्याट रुममा सामेल हुन मसँग आउनुहोस्।",
    enthusiastsFrom: "विश्वभरका उत्साहीहरू साझा गर्न एकसाथ आउँछन्...",
    igniteEndless: "अनन्त मनोरञ्जन प्रज्वलित गर्नुहोस्",
    download: "डाउनलोड गर्नुहोस्",
    halaLive: "हाला लाइभ",
    showMe: "मलाई खुशी संसार देखाउनुहोस्",
    saySomething: "केही भन...",
    downloadHala: "हाला एप डाउनलोड गर्नुहोस्",
  },
  starHost: {
    starHost: "स्टार होस्ट",
    level2: "स्तर {level} {days} दिनको लागि कायम राखिएको छ",
    currentSalary: "हालको तलब",
    points: "Points",
    likes: "मन पर्यो",
    stillNeed: "Still need",
    done: "भयो",
    numberOf2: "उपहार दिनेहरूको संख्या",
    gifters: "उपहार दिनेहरू",
    gcoinGifts: "Gcoin उपहारहरू",
    gifts: "gifts",
    liveDuration: "Live Duration",
    min: "न्यूनतम",
    completeAll: "स्तरोन्नति गर्न निम्न सबै कार्यहरू पूरा गर्नुहोस्",
    follower: "अनुयायी",
    numberOf3: "उपहार दिनेहरूको संख्या",
    daysAt: "{level} स्तरमा दिनहरू",
    giftCollection: "उपहार सङ्कलन",
    gift: "Gift",
    date: "Date",
    expectedSalary: "अपेक्षित तलब",
    gcoin: "जिकोइन",
    status: "स्थिति",
    levelReached: " स्तर पुग्यो",
    notAchieved: "हासिल भएन",
    starHost2: "स्टार होस्ट नियमहरू",
    eachStar: "प्रत्येक स्टार होस्टको ३-दिनको परीक्षण अवधि हुन्छ।",
    theyWill:
      "यदि उनीहरूले ३ दिनको लागि A-स्तरको मापदण्ड पूरा गरे भने मात्र उनीहरू आधिकारिक स्टार होस्ट बन्नेछन्।",
    thoseWho:
      "दैनिक ए-लेभल लक्ष्यहरू पूरा गर्न असफल हुनेहरूलाई बर्खास्त गरिनेछ।",
    firedHosts:
      "बर्खास्त गरिएका होस्टहरूले स्टार होस्टको आधारभूत तलब कमाउन सक्दैनन्",
    starHost3:
      "स्टार होस्टको आधारभूत तलब साप्ताहिक रूपमा, प्रत्येक सोमबार भुक्तानी गरिन्छ।",
    ifA:
      "यदि कुनै स्टार होस्टले दैनिक कार्यहरू पूरा गर्न असफल भएमा, उनीहरूले प्रति घण्टा तलबको ५०% मात्र पाउनेछन्।",
    selfGifting:
      "सबै उपहार लक्षित व्यक्तिहरूको लागि स्व-उपहार दिन कडा रूपमा निषेध गरिएको छ।",
    starHost4: "विभिन्न स्तरका स्टार होस्ट पुरस्कारहरू",
    level: "Level",
    dailyExtra: "दैनिक अतिरिक्त अंक पुरस्कारहरू",
    liveBroadcast: "प्रत्यक्ष प्रसारण समय आवश्यक छ",
    starHost5: "विभिन्न स्तरहरूको लागि स्टार होस्ट आवश्यकता",
    requirements: "आवश्यकता(हरू)",
    yourApplication: "तपाईंको आवेदन आधिकारिक निकायबाट स्वीकृत भएको छ।",
    stayOn: "७ दिनको लागि ए-लेभलमा रहनुहोस्",
    over1k: "१ हजार भन्दा बढी प्रशंसकहरू",
    totalGifter: "कुल उपहार दिने व्यक्तिको संख्या > ३००",
    receiveAll: 'सबै "भाग्यशाली" उपहारहरू प्राप्त गर्नुहोस्',
    everyLucky: "प्रत्येक भाग्यशाली उपहार संख्या १०० भन्दा बढी हुनुपर्छ।",
    stayOn2: "१० दिनको लागि एस-लेभलमा रहनुहोस्",
    over2k: "२ हजार भन्दा बढी प्रशंसकहरू",
    totalGifter2: "जम्मा उपहार दिने संख्या> ३००",
    receiveAll2: 'सबै "तातो" उपहारहरू प्राप्त गर्नुहोस्',
    stayOn3: "१० दिनको लागि SS-स्तरमा रहनुहोस्",
    over5k: "५ हजारभन्दा बढी प्रशंसकहरू",
    totalGifter3: "कुल उपहार दिने व्यक्तिको संख्या > १०००",
    receiveAll3: 'सबै "लक्जरी" उपहारहरू प्राप्त गर्नुहोस्',
    starHost6: "स्टार होस्ट दैनिक कार्यहरू",
    dailyAssessment: "(दैनिक मूल्याङ्कन प्रणाली): अन्तरक्रिया / उपहार",
    gcionGifts: "Gcion उपहारहरू",
    rulesTo: "स्टार होस्ट स्तर घटाउने नियमहरू",
    failTo: "लगातार ३ दिनसम्म हालको स्तरको मापदण्ड पूरा गर्न असफल।",
    failingTo: "हप्ता भित्र <span> ३ पटक मापदण्ड पूरा गर्न असफल",
    ifThe2:
      "यदि दैनिक आवश्यकता पूरा गर्न असफल हुने होस्ट A-स्तरको छ भने, उसलाई पदच्युत गर्नुको सट्टा सिधै बर्खास्त गरिनेछ। पदच्युत भएपछि, स्तर पुन: प्राप्त गर्न होस्टले लगातार ३ दिनसम्म मूल स्तरको मापदण्ड पूरा गर्नुपर्छ।",
    involvementIn: "ठूला उल्लङ्घन वा नकारात्मक घटनाहरूमा संलग्नता।",
    causingDamage: "प्लेटफर्मको रुचि वा ब्रान्ड छविमा क्षति पुर्‍याउने",
    applyFor: "आफैंले छोड्नको लागि आवेदन दिनुहोस्",
    liveStreaming: "लाइभ स्ट्रिमिङ आवश्यकताहरू",
    liveStream: "लाइभ स्ट्रिम सामग्री होस्टले तोकेको प्रकारसँग मिल्नु पर्छ।",
    roomHosts:
      "प्रसारणको समयमा कोठाका होस्टहरूलाई लामो समयसम्म आफ्नो माइक्रोफोन म्यूट गर्न निषेध गरिएको छ।",
    liveStreams:
      "लाइभ स्ट्रिमहरू ९-सिटर माइक्रोफोन कोठा लेआउट प्रयोग गरेर सञ्चालन गर्नुपर्छ।",
    otherSeats:
      "कोठाका अन्य सिटहरूमा प्रयोगकर्ताहरू वा दर्शकहरूले बस्न पाउँदैनन् जसले कार्य खेती गर्ने उद्देश्यका लागि आफ्नो माइक्रोफोन म्यूट गर्छन्।",
    discriminatoryInsulting:
      "कोठामा भेदभावपूर्ण, अपमानजनक वा आपत्तिजनक टिप्पणीहरू गर्न सख्त निषेध गरिएको छ।",
  },
  starRoom: {
    afterCountdown:
      "हरेक दिन काउन्टडाउन पछि, शीर्ष ३ कोठाहरू स्टार कोठा श्रेणीमा सूचीबद्ध हुनेछन्।",
    top20Star:
      "यस हप्ता पछि शीर्ष २० तारे कोठाहरूलाई प्रशस्त बोनसको रूपमा पुरस्कृत गरिनेछ।",
    countdown: "Countdown：",
    top3Daily:
      "दैनिक शीर्ष ३ कोठाहरू साप्ताहिक तारा कोठाहरूमा सामेल हुन योग्य हुनेछन्।",
    starRooms:
      "हप्ताको अन्तिम दिन तारा कोठाहरूको श्रेणीकरण गरिनेछ। यसलाई प्रत्येक कोठाको कुल सिक्का प्रवाहको आधारमा श्रेणीकरण गरिनेछ।",
    top20Weekly:
      "शीर्ष २० साप्ताहिक स्टार कोठा मालिकहरूले निम्न अनुसार पुरस्कारहरू पाउनेछन्",
    qualificationTo:
      "यस कार्यक्रममा भाग लिनको लागि योग्यता: कोठामा कुनै पनि उल्लङ्घन वा गैरकानूनी व्यवहार गर्न अनुमति छैन, एक पटक फेला परेपछि, हलाले कोठालाई अयोग्य घोषित गर्नेछ र श्रेणीबाट हटाउनेछ।",
    theRewards: "पुरस्कारहरू प्रत्येक सोमबार पठाइनेछ।",
    days: "days",
    coins: "Coins",
  },
  inviteActive: {
    inviteHosts: "आयोजकहरूलाई आमन्त्रित गर्नुहोस्",
    pointsMax: "दैनिक अधिकतम ५,००० अंक",
    firstRecharge: "पहिलो रिचार्ज प्रयोगकर्ताहरू",
    get20: "$२० नि:शुल्क पाउनुहोस्",
    oneInvite:
      "१. तपाईंले आमन्त्रित गर्नुभएको आयोजकहरू समाप्त भएपछि, प्रत्यक्ष सुरु गर्न होस्टहरूलाई आमन्त्रित गर्नुहोस्।",
    aFinish: "a. कार्य केन्द्रमा अनुहार प्रमाणीकरण पूरा गर्नुहोस्",
    bCreate: "ख. आफ्नै कोठा बनाउनुहोस्",
    cLive: "c. उनको कोठामा ३ घण्टा माइकमा लाइभ",
    dClaim: "पहिलो पटक प्रत्यक्ष पुरस्कार दाबी गर्नुहोस्",
    youGet:
      "तपाईंले आफ्नो मान्य आमन्त्रित होस्ट नम्बरहरूबाट हरेक दिन अंक पुरस्कारहरू प्राप्त गर्नुहुन्छ। तपाईं अर्को दिन पुरस्कारहरू दाबी गर्न सक्नुहुन्छ।",
    validHost: "मान्य होस्ट",
    pointsReward: "अंक पुरस्कार",
    youCan: " You can earn up to 5,000 invite points per day",
    myInvited: "मेरा आमन्त्रित आयोजकहरू",
    validHosts: "आज मान्य होस्टहरू",
    pointsRewards: "अङ्क पुरस्कारहरू",
    validHosts2: "हिजो मान्य होस्टहरू:",
    claim: "दाबी",
    claimed: "दाबी गरिएको",
    completedTime: "पूरा भएको समय",
    ifYour:
      "यदि तपाईंका साथीहरूले पहिलो रिचार्ज पूरा गरे भने, तपाईंले प्रशस्त पुरस्कारहरू पाउनुहुनेछ। (अफलाइन रिचार्ज पनि समावेश गरिनेछ)।",
    theMore:
      "पहिलो रिचार्ज रकम जति धेरै पुग्छ, त्यति नै धेरै सिक्का तपाईंलाई पुरस्कृत गरिनेछ, र यो दैनिक $२० सम्म हुन्छ।",
    inviteesRecharge: "आमन्त्रितहरू रिचार्ज सिक्काहरू",
    yourReward: "तपाईंको पुरस्कार सिक्का",
    threeOnly:
      "३. ३० दिन भित्र रिचार्ज गर्न आमन्त्रित गरिएका प्रयोगकर्ताहरूलाई मात्र मान्य पहिलो रिचार्ज प्रयोगकर्ताको रूपमा गणना गरिनेछ।",
    seniorAnd:
      "सिनियर र स्ट्यान्डर्ड विक्रेताहरूलाई केवल एप वा आधिकारिकबाट सिधै रिचार्ज गर्दा गणना गरिनेछ (भुक्तानी विधिहरूको लागि आफ्नो एडमिनकहाँ आउनुहोस्) पहिलो पटक मान्य पहिलो रिचार्ज प्रयोगकर्ताहरूको रूपमा गणना गरिनेछ।",
    myInvited2: "मेरा आमन्त्रित प्रयोगकर्ताहरू",
    rechargeCoins: "सिक्का रिचार्ज गर्नुहोस्",
    coinsRewards: "सिक्का पुरस्कारहरू",
    firstRecharge2: "हिजो पहिलो रिचार्ज सिक्का:",
    firstRecharge3: "पहिलो रिचार्ज सिक्का",
    firstRecharge4: "पहिलो पटक रिचार्ज गर्ने समय",
  },
  hostPolicy: {
    title: "होस्ट नीति",
    section1Title: "नयाँ होस्टको पहिलो हप्ताको आधारभूत तलब",
    requirement: "आवश्यकता",
    newHostsDesc: "पहिलो हप्तामा Hala मा सामेल हुने नयाँ होस्टहरू",
    activeTime: "माइकमा सक्रिय समय",
    oneHour: "१ घन्टा",
    twoHour: "२ घन्टा",
    threeHour: "३ घन्टा",
    baseSalary: "आधारभूत तलब (अंक)",
    incomeRequirement: "आम्दानी आवश्यकता",
    none: "कुनै पनि",
    remarks: "टिप्पणीहरू",
    remarksDesc:
      "अधिकतम ३ घन्टा/दिन। अधिकतम ७ दिन। कुल अधिकतम पुरस्कार ३५,००० अंक",
    note1: "होस्टको दर्ता मितिबाट, ७ दिने आधारभूत तलब मान्यता अवधि सुरु हुन्छ।",
    note2:
      "बहु खाताहरू प्रयोग गर्ने वा बहु आईपी वा उपकरणहरूमा लगइन गर्ने होस्टहरूलाई आधारभूत तलब पुरस्कारबाट अयोग्य ठहराइनेछ।",
    note3:
      "यदि होस्टको गत ७ दिनको आम्दानी १५०,००० अंकभन्दा बढी छ, उनीले नयाँ होस्ट आधारभूत तलब पुरस्कारको सट्टामा सामान्य होस्ट घण्टा पुरस्कार पाउनेछिन्।",
    section2Title: "सामान्य होस्ट समान पुरस्कार",
    level: "स्तर",
    incomeRequirementShort: "आम्दानी आवश्यकता",
    hourlyReward: "घण्टा पुरस्कार",
    maximumDailyHours: "अधिकतम दैनिक घन्टा",
    section2Note1: "माइकमा लगातार १५ मिनेट प्रभावकारी समयको रूपमा गणना गरिनेछ।",
    section2Note2:
      "सबै पुरस्कारहरू अंकहरूमा तिर्नुहुन्छ र कार्य प्रणालीमा दावा गर्न आवश्यक छ।",
    section2Note3: "प्लेटफर्म पुरस्कारहरू अंक आवश्यकतामा गणना गरिने छैनन्।",
    section2Note4:
      "एक पटक बहु IP वा उपकरणहरू पत्ता लगाइएमा अंकहरू कटौती गरिनेछ।",
    section2Note5:
      "गत ७ दिनको अर्थ गत ६ दिन+आज हो, त्यसैले तपाईं उच्च अंक स्तरमा समयमै पुग्नुभयो तपाईंको घण्टा पुरस्कारहरू बढ्न सक्छन्।",
    section2Note6:
      "L-स्तर गैर-लक्ष्य पुरस्कारहरू दर्ता भएपछिको पहिलो ७ दिनमा मात्र मान्य हुनेछन्। ७ दिनपछि, होस्टहरूले स्थायी रूपमा प्रतिदिन ५०० निःशुल्क अंकहरू प्राप्त गर्न सक्छन्।",
    section3Title: "होस्ट नियमहरू",
    regulation1: "होस्टहरूले बहु खाताहरू दर्ता गर्न प्रतिबन्ध छ।",
    regulation2: "तेस्रो पक्ष प्लेटफर्महरू प्रवर्द्धन गर्न प्रतिबन्ध छ।",
    regulation3: "नाबालकहरूलाई अत्यधिक प्रतिबन्ध छ।",
    regulation4:
      "होस्टसँग एउटा मात्र प्रमाणित आईडी हुन सक्छ। प्रमाणित आईडीहरूले मात्र प्रत्यक्ष प्रसारण सुरु गर्न र आम्दानी निकाल्न सक्छन्।",
    regulation5:
      "प्रत्यक्ष प्रसारण सुरु गर्न वा आम्दानी निकाल्न अनुहार अनुहरण प्रमाणीकरण गर्ने कुनै पनि कार्यलाई स्थायी रूपमा प्रतिबन्ध लगाइनेछ।",
    regulation6:
      "प्रत्यक्ष प्रसारणको लागि अन्य प्रतिहरूलाई आईडी प्रदान गर्नाले आईडीलाई प्रणालीद्वारा स्थायी रूपमा प्रतिबन्ध लगाउनेछ।",
    regulation7:
      "आवाज कोठामा, होस्टहरूले कोठामा प्रवेश गर्ने प्रयोगकर्ताहरूलाई सक्रिय रूपमा अभिवादन गर्नुपर्छ।",
    regulation8:
      "आवाज कोठाको आवरण फोटोले होस्टको वास्तविक, अनुपालित फोटो प्रयोग गर्नुपर्छ।",
    regulation9:
      "Hala प्लेटफर्मले कुनै पनि धोखाधडी गतिविधिहरूलाई कडाप्रतिबन्ध गर्दछ। कुनै पनि उल्लंघनले खाता स्थायी निलम्बनको कारण बन्नेछ।",
    footer:
      "Hala ले माथि उल्लिखित नीतिहरूको अन्तिम व्याख्याको अधिकार सुरक्षित राख्छ।",
  },
  correspondingRevenue:
    "सम्बन्धित आय आवश्यकता पूरा भएमा। सबै पुरस्कारहरू जारी गरिनेछ",
  within12: "घटना समाप्त भएपछि १-२ कार्यदिन भित्र",
};
